var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SlidePop',{attrs:{"show":_vm.show,"slide":1},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"second",fn:function(){return [_c('CouponUseInfo',{attrs:{"data":_vm.data,"hideBackBtn":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }